import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  props: {
    laiseeInfo: {
      type: Object,
      default: null
    },
    laiseeStatus: {
      type: Object,
      default: null
    },
    laisee: {
      type: Object,
      default: null
    },
    day: {
      type: Number,
      default: 0
    }
  },
  components: {
    Avatar: Avatar
  }
};